import React, { useContext, useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import "./ServiceHistory.css"
import { Row, Col, Button } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import { HeaderTitle, Loading } from '../Library'
import dayjs from 'dayjs'
import { listHistoryStatus, taskStatus } from '../Network/Repair'

function ServiceHistory() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.service
    const [isLoading, setLoading] = useState(false)
    const [historyList, setHistoryList] = useState([])
    const [page, setPage] = useState(1)
    const [lastLength, setLastLength] = useState(0)
    const size = 12

    const fetchHistoryList = (page, size, loadnew) =>{
        setLoading(true)
        listHistoryStatus(page, size,
            (data)=>{
                console.log(data)
                if(loadnew){
                    setHistoryList(data)
                }else{
                    data.map((item)=>{
                        setHistoryList(oldData => [...oldData, item])
                    })
                }
                setLastLength(data.length)
                setLoading(false)
            },
            (error)=>{
                setLoading(false)
            })
    }

    const loadMore = () =>{
        setPage(page + 1)
        fetchHistoryList(page + 1, size, false)
    }

    const onScroll = (event) =>{
        const target = event.target
        if(target.scrollHeight - target.scrollTop === target.clientHeight){
            if(lastLength >= size){
                loadMore()
                console.log("Bottom")
            }
        }
    }

    useEffect(()=>{
        fetchHistoryList(page, size, true)
    },[])

    return (
        <div id="service-history">
            { isLoading ? <Loading/>: null }
            <HeaderTitle title={lang.repair_history} isShowBack backTo="/"/>
            <div className="history-container" onScroll={onScroll}>
                <Row>
                { historyList.map((item, key)=>
                    <Col key={key} md={6} xl={4}>
                        <ServiceItem 
                        title={item.repairType}
                        detail={item.remark}
                        status={item.status}
                        date={item.createdDate}
                        completeDate={item.completeDate}
                        ticketNumber={item.ticketNumber}
                        />
                    </Col>
                )}
                </Row>
                { historyList.length === 0 ?
                <div style={{ textAlign: 'center' }}>
                    {lang.no_history}
                </div>
                : null
                }
                { lastLength >= size ?
                <div style={{ textAlign: 'center' }}>
                    <Button
                    onClick={()=>loadMore()}
                    >
                        {lang.load_more}
                    </Button>
                </div>
                : null
                }
            </div>
        </div>
    )
}

function ServiceItem({ title, detail, date, completeDate, ticketNumber, status }){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.service
    const langRepair = langCx.lang.repair_service

    var statusIcon = faTimesCircle
    var statusColor = "red"
    var statusLabel = langRepair.cancelled
    
    switch(status){
        case(taskStatus.COMPLETE):
            statusIcon = faCheckCircle
            statusColor = "green"
            statusLabel = langRepair.complete
            break
        default:
            statusIcon = faTimesCircle
            statusColor = "red"
            statusLabel = langRepair.cancelled
            break
    }

    return(
        <div className="service-item">
            <div className="title">{title}</div>
            <div className="desc">{detail}</div>
            <div className="desc">{lang.datetime + " : " + dayjs(date).format("DD MMM YYYY H:mm")}</div>
            <div className="status">
                <div className="icon">
                    <FontAwesomeIcon icon={statusIcon} color={statusColor} className="icon"/>
                </div>
                <div>
                    <div className="status-label">{statusLabel}</div>
                    { status === taskStatus.COMPLETE ?
                    <div className="status-complete-date">{dayjs(completeDate).format("D MMM YYYY H:mm")}</div>
                    : null
                    }
                    <div className="status-ticket">{lang.ticket_number + " : " + ticketNumber}</div>
                </div>
            </div>
        </div>
    )
}

export default ServiceHistory
